export const OPEN_RIGHT_SIDEBAR = "OPEN_RIGHT_SIDEBAR";
export const CLOSE_RIGHT_SIDEBAR = "CLOSE_RIGHT_SIDEBAR";
export const TOGGLE_RIGHT_SIDEBAR = "TOGGLE_RIGHT_SIDEBAR";

export const FETCH_SASURL_REQUEST = "FETCH_SASURL_REQUEST";
export const FETCH_SASURL_SUCCESS = "FETCH_SASURL_SUCCESS";
export const FETCH_SASURL_NEW_WINDOW_SUCCESS = "FETCH_SASURL_NEW_WINDOW_SUCCESS";
export const FETCH_SASURL_FAILURE = "FETCH_SASURL_FAILURE";
